var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[[_vm._m(0)],_c('div',[_c('v-card-actions',[_c('v-btn',{attrs:{"color":"primary"}},[_vm._v("Voltar")])],1)],1)],2)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('iframe',{staticStyle:{"width":"100%","height":"500px"},attrs:{"src":"http://192.168.20.2:8085/readfile/1.pdf","title":"SoftlineAngola"}})])
}]

export { render, staticRenderFns }